export const STEP_BRANDING_STAGE = 'branding_stage';
export const STEP_INDUSTRY = 'industry';
export const STEP_LOGO = 'logo';
export const STEP_PROMOTION = 'promotion';
export const STEP_PRODUCT_PREFERENCES = 'product_preferences';

export const TAG_LOGO = 'logo';
export const TAG_COLORS_FONTS = 'colors & fonts';
export const TAG_WEBSITE = 'website';
export const TAG_SOCIAL_MEDIA = 'social media';
export const TAG_STATIONARY = 'stationary';
export const TAG_PRODUCT_PACKAGING = 'product packaging';
export const TAG_PRODUCT_LABEL = 'product label';
export const TAG_SIGNAGE = 'signage';
export const TAG_BUSINESS_CARDS = 'business cards';
export const TAG_BROCHURES = 'brochures';
export const TAG_BRANDING_GUIDELINES = 'branding guidelines';
export const TAG_ONLINE = 'online';
export const TAG_OFFLINE = 'offline';
